module.exports = __webpack_public_path__ + "assets/media/app-store.20223e10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoSuccessStep/app-store.svg
// module id = 3230
// module chunks = 0